export const initialState = {
    chainId: null,
    web3: null,
    ethWeb3: null,
    polWeb3: null,
    onBoard: null,
    walletAddress: '',
    connected: false
};